import styled from 'styled-components'

export const OrderPackageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  width: 100%;
  margin-bottom: 2rem;
`
